import { css } from '@emotion/react';

import { Skeleton } from '@/components/ui/skeleton';
import { mq, spacing } from '@/theme/tokens';

export function EditorSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading project editor"
      css={css`
        padding: ${spacing.lg};
        height: calc(100vh - 56px);
        display: flex;
        flex-direction: column;
      `}
    >
      {/* Title row */}
      <div
        css={css`
          margin-bottom: ${spacing.md};
        `}
      >
        <Skeleton width="200px" height="2rem" />
      </div>

      {/* WPM selector row */}
      <div
        css={css`
          margin-bottom: ${spacing.md};
        `}
      >
        <Skeleton width="300px" height="32px" borderRadius="6px" />
      </div>

      {/* Two-column body */}
      <div
        css={css`
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: ${spacing.lg};
          min-height: 0;

          ${mq.lg} {
            flex-direction: row;
          }
        `}
      >
        {/* Editor area */}
        <div
          css={css`
            flex: 1;
            min-height: 300px;

            ${mq.lg} {
              min-height: 0;
            }
          `}
        >
          <Skeleton width="100%" height="100%" borderRadius="6px" />
        </div>

        {/* Right sidebar */}
        <div
          css={css`
            flex: 0 0 320px;
            display: flex;
            flex-direction: column;
            gap: ${spacing.md};
          `}
        >
          <Skeleton width="100%" height="120px" borderRadius="6px" />
          <Skeleton width="60%" height="1.25rem" />
          <Skeleton width="100%" height="80px" borderRadius="6px" />
          <Skeleton width="100%" height="80px" borderRadius="6px" />
        </div>
      </div>
    </div>
  );
}
